import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTextAlignLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.125 4.6875C2.77982 4.6875 2.5 4.96732 2.5 5.3125C2.5 5.65768 2.77982 5.9375 3.125 5.9375H16.875C17.2202 5.9375 17.5 5.65768 17.5 5.3125C17.5 4.96732 17.2202 4.6875 16.875 4.6875H3.125ZM3.125 7.8125C2.77982 7.8125 2.5 8.09232 2.5 8.4375C2.5 8.78268 2.77982 9.0625 3.125 9.0625H13.125C13.4702 9.0625 13.75 8.78268 13.75 8.4375C13.75 8.09232 13.4702 7.8125 13.125 7.8125H3.125ZM2.5 11.5625C2.5 11.2173 2.77982 10.9375 3.125 10.9375H16.875C17.2202 10.9375 17.5 11.2173 17.5 11.5625C17.5 11.9077 17.2202 12.1875 16.875 12.1875H3.125C2.77982 12.1875 2.5 11.9077 2.5 11.5625ZM3.125 14.0625C2.77982 14.0625 2.5 14.3423 2.5 14.6875C2.5 15.0327 2.77982 15.3125 3.125 15.3125H13.125C13.4702 15.3125 13.75 15.0327 13.75 14.6875C13.75 14.3423 13.4702 14.0625 13.125 14.0625H3.125Z",
		fill: "currentColor"
	})
});
export default SvgTextAlignLeft;
